export const paymetnFields = [
  {
    key: "sumRestOfBasicDebt",
    label: "Основной долг",
    description: "Задолженность за коммунальные услуги",
    required: false,
  },
  {
    key: "sumFine",
    label: "Пени",
    description: "Начислены за просрочку",
    required: false,
  },
  {
    key: "stateFee",
    label: "Госпошлина",
    description: "Обязательный судебный сбор",
    required: false,
  },
  {
    key: "eePostCost",
    label: "Почтовые расходы",
    description: "Стоимость отправки уведомлений",
    required: false,
  },
  {
    key: "extraExpensesWithoutPostCost",
    label: "Прочие расходы",
    description: "Дополнительные издержки",
    required: false,
  },
];
